var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependant01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2267 29.25H36.2017C35.0082 29.25 33.8636 28.7759 33.0197 27.932C32.1758 27.0881 31.7017 25.9435 31.7017 24.75C31.7017 25.9435 31.2276 27.0881 30.3836 27.932C29.5397 28.7759 28.3951 29.25 27.2017 29.25C26.0082 29.25 24.8636 28.7759 24.0197 27.932C23.1758 27.0881 22.7017 25.9435 22.7017 24.75C22.7017 25.9435 22.2276 27.0881 21.3836 27.932C20.5397 28.7759 19.3951 29.25 18.2017 29.25H16.1767M12.5767 9H19.3267M19.8149 47.25H34.5884C36.1149 47.25 37.6162 47.6382 38.9513 48.3782C40.2864 49.1182 41.4114 50.1856 42.2204 51.48L42.3892 51.75H47.4517V2.25H6.95166V51.75H12.0142L12.1829 51.48C12.9919 50.1856 14.1169 49.1182 15.452 48.3782C16.7871 47.6382 18.2885 47.25 19.8149 47.25ZM27.2017 38.25C24.218 38.25 21.3565 37.0647 19.2467 34.955C17.1369 32.8452 15.9517 29.9837 15.9517 27C15.9517 24.0163 17.1369 21.1548 19.2467 19.045C21.3565 16.9353 24.218 15.75 27.2017 15.75C30.1853 15.75 33.0468 16.9353 35.1566 19.045C37.2664 21.1548 38.4517 24.0163 38.4517 27C38.4517 29.9837 37.2664 32.8452 35.1566 34.955C33.0468 37.0647 30.1853 38.25 27.2017 38.25Z",
    stroke: "#278DEC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependant01);
export default __webpack_public_path__ + "static/media/independant01.4f412a77b5db476483708e86c8c8fb0e.svg";
export { ForwardRef as ReactComponent };